var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.768,
    height: 29.343,
    viewBox: "0 0 23.768 29.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-file-unknown-4998912",
    transform: "translate(-131.339 -53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46004",
    "data-name": "Group 46004",
    transform: "translate(131.339 53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54251",
    "data-name": "Path 54251",
    d: "M10.267-.873A3.53,3.53,0,0,0,6.746,2.648v22.3a3.53,3.53,0,0,0,3.521,3.521H26.993a3.53,3.53,0,0,0,3.521-3.521V8.223a4.1,4.1,0,0,0-1.2-2.9l-5-5a4.1,4.1,0,0,0-2.9-1.2Z",
    transform: "translate(-6.746 0.873)",
    fill: "#e0e1e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54252",
    "data-name": "Path 54252",
    d: "M19.928,8.245A4.287,4.287,0,0,1,24.2,12.518a4.228,4.228,0,0,1-3.382,4.092v2.422a.89.89,0,1,1-1.78,0V15.9h0a.89.89,0,0,1,.89-.89h0a2.493,2.493,0,1,0-2.493-2.493.89.89,0,1,1-1.78,0,4.287,4.287,0,0,1,4.273-4.273Zm0,13.1a.89.89,0,1,1-.89.89A.89.89,0,0,1,19.929,21.345Z",
    transform: "translate(-8.045 -0.996)",
    fill: "#9099ad",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherFile);
export default __webpack_public_path__ + "static/media/otherFile.8af53e7569ae6ae355a5f12c8d67a10d.svg";
export { ForwardRef as ReactComponent };